import React from "react";
import { Dispatcher } from "../../flux";

const lookupWikipedia = function(isbn, selectionData) {
  window.open(
    "https://en.wikipedia.org/w/index.php?search=" +
      selectionData.currentSelectedText
  );
  Fraction.Reporter.gaEvent(
    "wikipedia-lookup",
    selectionData.currentSelectedText,
    isbn
  );
};

module.exports = {
  metadata: () => {
    return {
      id: "wikipedia-lookup",
      name: i18n.t("wikipedia-lookup.lookup-in-wikipedia"),
      description: i18n.t("wikipedia-lookup.description"),
      enabled: (isbn, selectionData) => {
        return (
          Fraction.Brand.Sidekick.wikipediaLookup &&
          selectionData.currentSelectedText &&
          selectionData.currentSelectedText.split(/\s+/).length <= 5
        );
      },
      action: lookupWikipedia,
      defaultEnabled: () => {
        return true;
      },
      expanded: true,
      type: "context"
    };
  }
};
